import axios from 'axios'
import format from 'date-fns/format'
import BaseService from './BaseService';
import entities from 'src/config/entities';
import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'
import FileService from 'src/services/FileService'

class InvoiceLinesService extends BaseService {

  constructor () {
    super({entity: entities.INVOICE_LINE});
  }

  getInvoiceLinesPerClient(params) {
    return super.get(params, '/bulk-invoices')
  }

  async export() {
    try {
      let res = await axios.get(`/invoice-lines/export`, {
        responseType: 'blob'
      })

      let fileName = `invoice-lines-${format(new Date(), FRIENDLY_DATETIME_FORMAT)}.csv`
      FileService.downloadFileInBrowser(res, fileName)
    } catch (e) {
      this._handleError({ translationKey: 'generic.exportError', error: e });
      throw e;
    }
  }
}

export default new InvoiceLinesService();
